/**
 * Domain Crawler.
 * @format
 */

/**
 * Domain Check.
 * Disable indexing of d8-prod subdomain.
 */
export const domainCheck = (): void => {
  const { host }: Location = window.location;
  const subdomain: string = host.split('.')[0];

  if (subdomain === 'd8-prod') {
    const robotTag: HTMLMetaElement = document.createElement('meta');
    robotTag.setAttribute('name', 'robots');
    robotTag.setAttribute('content', 'noindex, nofollow');
    document.getElementsByTagName('head')[0].appendChild(robotTag);
  }
};
